const Loading = () => (
	<div className = "d-flex justify-content-center page-loading" >
		<div className="spinner-border text-primary" role="status" />
	</div >
)

export default Loading;